import React, { useEffect, useState } from "react";
import './Popup.scss';
import { cdnImage } from "../../helper/constants";

const PopUp = ({ handleClose ,data}) => {
    const [showPolicy, setShowPolicy] = useState(false);
    const [showDescription,setShowDescription]=useState(true);

    useEffect(() => {

    }, [])

    const openTNC = () => {
        setShowPolicy(true);
        setShowDescription(false);
    }
    const backBtn = () => {
        setShowPolicy(false);
        setShowDescription(true);
    }

    const acceptedBtn = () => {
        localStorage.setItem('privacy-policy-accepted', true);
        handleClose();
    }

    const declinedBtn = () => {
        localStorage.setItem('privacy-policy-accepted', false);
        handleClose();
    }

    return (<>
        <div id="privacy_popup" className="privacyModal close-popup">
            <div className="privacy-content">
                <div className="privacy-header">
                    <h4>
                       {!showDescription &&  <img onClick={backBtn} src={`${cdnImage}assets/images/back_arrow_icon.svg`}id="arrow_left"
                        />}
                        {data?.title} </h4> <button onClick={declinedBtn} type="button" className="close" id="privacy_popup_close"
                        >×</button>
                </div>
                <div className="privacy-body">
                    {showDescription && <p id="privacy_policy_text" >{data?.description}
                        <br />
                        <span id="tNc_link" onClick={openTNC}>{data?.title}</span>
                    </p>}
                  {showPolicy &&   <div id="tnc_wrap" className="tnc_wrap">
                        <p> {data?.tnc?.title} </p>
                        <p>

                            {data?.tnc?.content1}
                        </p>
                        <p>
                          {data?.tnc?.content2}

                        </p>
                    </div>}

                </div>
                <div className="privacy-footer">
                    <button className="privacy_btn" onClick={declinedBtn}>
                        {data?.tnc?.action1}
                    </button>
                    <button className="privacy_btn" onClick={acceptedBtn}>
                        {data?.tnc?.action2}
                    </button>


                </div>


            </div>
        </div>

    </>)
}
export default PopUp